var customer = [{first_name: ""}, {last_name : ""}, {email : ""}, {tags : ""}];
var customer_company = [{first_name: ""}, {last_name : ""}, {email : ""}, {tags : ""}];
let valid_domains = [];

//add customer tag
var customerTag = function(){
  if(document.querySelector('#create_customer input[name="customer[email]"]')){

    document.querySelector('#create_customer input[name="customer[email]"]').addEventListener('keyup', function(){
      console.log(this.value.split('@')[this.value.split('@').length - 1]);
      this.form.querySelector('input[name="customer[tags]"]').value = this.value.split('@')[this.value.split('@').length - 1].toLowerCase().trim().replace(/[^0-9a-zA-Z.]/g, '').replace(/\./g, '-');
    });
  }

//   if(document.querySelector('#contact_form input[name="contact[email]"]')){
//     document.querySelector('#contact_form input[name="contact[email]"]').addEventListener('keyup', function(){
//       console.log(this);
//       this.form.querySelector('input[name="contact[tags]"]').value = this.value.split('@')[this.value.split('@').length - 1].toLowerCase().trim().replace(/[^0-9a-zA-Z.]/g, '').replace(/\./g, '-');
//     });
//   }
}

customerTag();

document.addEventListener("cartMarkup:updated", (ev) => {
  console.log(ev);
  let cartMarkup = ev.detail.cartMarkup;  

  let subtotal = document.querySelector("[data-subtotal]");
  console.log(subtotal.getAttribute("data-new-subtotal"));

  

  // let ajaxcart__subtotal_value = document.querySelector(".ajaxcart__subtotal-value");
  // ajaxcart__subtotal_value.innerHTML = subtotal.dataset.newSubtotal;  
  
})

// cart drawer checkbox
var terms_checkbox = document.querySelector('.cart__terms-checkbox');
var checkoutBtn = document.querySelector('#draw_checkout');
console.log(checkoutBtn);
terms_checkbox.addEventListener('change', ()=>{
  if (terms_checkbox.checked){
    console.log('checked');
    checkoutBtn.setAttribute('name','checkout');
    checkoutBtn.removeAttribute('disabled');
    checkoutBtn.classList.remove('disabled');
  }
  else{
    console.log('unchecked');
    checkoutBtn.removeAttribute('name');
    checkoutBtn.setAttribute('disabled','disabled');
    checkoutBtn.classList.add('disabled');
  }
})

jQuery(function($){
    var i=0;
    setTimeout(() => {
    	$('.boost-sd__product-price').each(function(){
          var $this = $(this);
      		console.log(++i);
          var gridPrice = Number($this.find('.grid-product__price-bold').text().replace(/[^0-9.-]+/g,"")) *100;
          console.log("Price: "+  gridPrice);
          //var gridOrigPrice = Number($this.find('.grid-product__price-bold').data('original-price').replace(/[^0-9.-]+/g,"")) *100;
      
      	 // var gridOrigPrice = Number($this.find('.grid-product__price--original').text().replace(/[^0-9.-]+/g,"")) *100;
          var gridOrigPrice = Number($this.find('.grid-product__price-bold').attr('data-original-price').replace(/[^0-9.-]+/g,"")) *100;
          console.log("origPrice: "+  gridOrigPrice);
      
          var gridCompareAtPrice = Number($this.find('.grid-product__price-bold').attr('data-compare-at-price').replace(/[^0-9.-]+/g,"")) *100;
          console.log("compareAtPrice: "+  gridCompareAtPrice);
      
          if(gridPrice < gridOrigPrice){
            if(gridCompareAtPrice > 0){var savedAmount = theme.Currency.formatMoney( (gridCompareAtPrice - gridPrice), theme.settings.moneyFormat);//console.log('savedAmount: '+savedAmount);
              //console.log($this.find('.grid-product__price-savings_amount').text());
              //$this.find('.grid-product__price--original').text($this.find('.grid-product__price-bold').data('original-price'));
              $this.find('.grid-product__price-savings_amount').text(savedAmount);
            } else{var savedAmount = theme.Currency.formatMoney( (gridOrigPrice - gridPrice), theme.settings.moneyFormat);// $this.find('.grid-product__price-savings_amount').text(savedAmount);
            }
          }        
    	});
    }, 1000);
  	
  });

 /*
jQuery(function($){
  
  $(document).ready(function(){
    $('.form-customer').hide();
    
    customerTag();
    
    $('.customer_first_name').on('change', function(){
      customer_company.first_name = $(this).val();
      $('#FirstNameCustomer').val(customer_company.first_name);
      
      customer.first_name = $(this).val();
      $('#FirstName').val(customer.first_name);
      
      customerTag();
    });
    
    $('.customer_last_name').on('change', function(){
      customer_company.last_name = $(this).val();
      $('#LastNameCustomer').val(customer_company.last_name);
      
      customer.last_name = $(this).val();
      $('#LastName').val(customer.last_name);
      
      customerTag();
    });
    
    $('.customer_email').on('keyup', function(e){
      var $form = $(this).parent('.form-vertical');
      var $email = $(this).val();
      var key =  e.keyCode ? e.keyCode : e.which;
      var $domain = $email.split('@')[1];
      
      if($domain){
        var $domain_found = Object.keys(valid_domains).find(key => valid_domains[key] === $domain);
        
        if($domain_found > -1){
          customer_company.email = $email;
          customer_company.tags = $email.split('@')[$email.split('@').length - 1].toLowerCase().trim().replace(/[^0-9a-zA-Z.]/g, '').replace(/\./g, '-');
          
          $('#FirstNameCustomer').val(customer_company.first_name);
          $('#LastNameCustomer').val(customer_company.last_name);
          $('#EmailCustomer').val(customer_company.email);
          $('#TagsCustomer').val(customer_company.tags);
          
          $('.form-create_customer').hide();
          $('.form-customer').show();
          $('.form-customer').find('.customer_email').focus();
        } else{
          customer.email = $email;
          customer.tags = $email.split('@')[$email.split('@').length - 1].toLowerCase().trim().replace(/[^0-9a-zA-Z.]/g, '').replace(/\./g, '-');
          
          $('#FirstName').val(customer.first_name);
          $('#LastName').val(customer.last_name);
          $('#Email').val(customer.email);
          $('#Tags').val(customer.tags);
          
          $('.form-create_customer').show();
          $('.form-customer').hide();
          
          $('.form-create_customer').find('.customer_email').focus();
        } 
        
        customerTag();
      }
      
    });   
    
    //$('#success-modal').modal();
    
    var url = new URL(location.href);
    //console.log(url);
    var params = new URLSearchParams(url.search);    
    var customer_posted = params.get('customer_posted');
    //console.log('customer_posted: '+customer_posted);
    //if(customer_posted == 'true'){console.log('t t');}
    var hash = url.hash;
    //console.log('hash: '+ typeof hash);
    //if(hash.indexOf('contact_form') > -1){console.log('c c');}
    if((customer_posted == 'true') ){   //&& (hash == '#contact_form')
      $('.form-create_customer').hide();
      $('.form-customer').show();
      $('#success-modal').modal();
      //$('.form-customer-success').focus();
    }	

  });
}); */

// Custom Meta Title and Description for Store Locator Page
if (window.location.pathname.includes('/apps/store-locator')) {
  document.title = "Appliances/Electronic Store Locator - Voltas Store near me";
  let metaDescription = document.querySelector('meta[name="description"]');
  const descriptionContent = "Exclusive Voltas Stores with great offers. Enter your location to find the nearest Voltas store (A TATA Enterprise). Get store address, contact no. and Map.";
  
  if (metaDescription) {
    metaDescription.setAttribute('content', descriptionContent);
  } else {
    metaDescription = document.createElement('meta');
    metaDescription.name = "description";
    metaDescription.content = descriptionContent;
    document.head.appendChild(metaDescription);
  }
}